"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.clientHistory = exports.LastViewed = void 0;
const constants_1 = require("../../constants");
var LastViewed;
(function (LastViewed) {
    LastViewed["LineOfBusinessId"] = "lineOfBusinessId";
    LastViewed["LineOfBusiness"] = "lineOfBusiness";
})(LastViewed = exports.LastViewed || (exports.LastViewed = {}));
const clientHistory = ({ environment, redirectUrls, defaults: { redirectUrl, clientId: defaultClientId, lineOfBusiness }, }) => ({
    redirectUrl: () => redirectUrls[localStorage.getItem(LastViewed.LineOfBusiness)] ||
        redirectUrl,
    lastSelected(clients, id = localStorage.getItem(LastViewed.LineOfBusinessId)) {
        const businessLines = clients.reduce((all, { businessLines: lobs }) => [...all, ...lobs], []);
        const [firstBusinessLine] = businessLines;
        const lastViewed = businessLines.find(({ id: lobId }) => id === `${lobId}`);
        const defaultBusinessLine = environment === constants_1.Environment.Production
            ? firstBusinessLine
            : businessLines.find(({ clientId, name }) => clientId === defaultClientId && name === lineOfBusiness);
        return lastViewed || defaultBusinessLine || firstBusinessLine;
    },
    updateLastSelected({ id, name }) {
        localStorage.setItem(LastViewed.LineOfBusinessId, `${id}`);
        localStorage.setItem(LastViewed.LineOfBusiness, name);
    },
});
exports.clientHistory = clientHistory;
